import { render, staticRenderFns } from "./RadarIndex.vue?vue&type=template&id=487fa25a&"
import script from "./RadarIndex.vue?vue&type=script&lang=js&"
export * from "./RadarIndex.vue?vue&type=script&lang=js&"
import style0 from "./RadarIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports